<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" style="height: fit-content"
                      v-if="amReady">
    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          class="p-3"
          formTitle="Add Fusion Server"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-4">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search name or ip"></dg-text-field>
      </div>
      <div class="col-12 col-md-8">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <el-dialog :append-to-body="true" :visible.sync="deleteDialogVisible" center title="Delete" width="420px">
      <div v-if="deleteDialogVisible">
        <div align="center" class="mt-2 mb-4" style="word-break: break-word;">are you sure you  want to remove <br><b>"{{ selectedServer.data.name }}"</b> server ?
        </div>
        <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="rebootDialog" center title="Reboot" width="420px">
      <div align="center" class="mt-2 mb-2">You want to <b>Reboot</b> this server ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="rebootDialog = false" size="small">Cancel</el-button>
        <el-button @click="rebootServerApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import workingStatus from './ag-grid/WorkingStatus'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import agGridLink from '@/components/ag-grid-link/View'
import editOnFlyCell from "@/components/ag-grid-edit-on-fly-cell/View";

export default {
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('./../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  data() {
    return {
      selectedServer: {},
      deleteDialogVisible: false,
      selectedServerselectedServer: false,
      rebootDialog: false,
      interval: false,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 20,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0; overflow-x: hidden !important',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          getRowNodeId: data => {
            data.id
          },
          onGridReady: function (params) {
            /*params.api.sizeColumnsToFit()*/
          }
        },
        columnDefs: [
          {
            field: 'name',
            width: 180,
            headerName: 'Name',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            suppressKeyboardEvent: (params) => {
              return true
            },
            cellRendererFramework: $vue.extend(editOnFlyCell),
            cellRendererParams: {
              props: {
                inputWidth: '180px',
                valuePropertyName: 'name',
                saveAction: this.updateNameField
              }
            }
          },
          {
            field: 'url',
            width: 100,
            headerName: this.$ml.get('url'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(agGridLink),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler,
                urlProp: 'url',
                textFromProp: 'url',
                text: 'Log'
              }
            }
          },
          {
            field: 'password',
            headerName: 'Password',
            width: 100,
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(editOnFlyCell),
            cellRendererParams: {
              props: {
                inputWidth: '180px',
                valuePropertyName: 'password',
                saveAction: this.updatePasswordField
              }
            }
          },
          {
            field: 'ip_to_allow',
            headerName: "IP",
            width: 100,
            headerClass: this.$langConfig.lang + '-lang-text',
            autoHeight: true
          },
          {
            field: 'is_for_generate_live_users',
            headerName: "GL-User",
            width: 100,
            headerClass: this.$langConfig.lang + '-lang-text',
            autoHeight: true,
            cellRenderer: (params) => {
              let val = params.data.is_for_generate_live_users
              let span = document.createElement('span')
              span.innerHTML = (val == 1) ? 'Yes' : 'No'
              return span
            },
          },
          {
            width: 70,
            headerName: "Status",
            headerClass: this.$langConfig.lang + '-lang-text',
            cellRendererFramework: $vue.extend(workingStatus),
          },
          {
            width: 120,
            headerName: "LHB",
            field: 'last_heart_beat',
            headerClass: this.$langConfig.lang + '-lang-text',
          },
          {
            width: 120,
            headerName: "LDC",
            field: 'last_freeswitch_destroyed_channel_time',
            headerClass: this.$langConfig.lang + '-lang-text',
          },
          {
            width: 80,
            headerName: "",
            headerClass: this.$langConfig.lang + '-lang-text',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  beforeMount() {
    this.amReady = true
    this.currentPage = parseInt(this.$route.params.listPage)
    this.interval = setInterval(() => {
      this.getEntityListData(this.currentPage, true)
    }, 5000)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    rebootAction(params) {
      this.selectedServer = params.data
      this.rebootDialog = true
    },
    rebootServerApi() {
      this.rebootDialog = false
      let data = {
        url: this.selectedServer.url + '/commands/portal-commands.php?key=' + this.selectedServer.api_key,
        command: 'reboot'
      }

      $store.dispatch('network-server-api/portalCommand', {data}).then(r => {
        if (r == '1' || r == 1) {
          $gn.dialog.open('Attention', 'Server rebooting will begin in 1 minute')
        } else {
          $gn.dialog.open('Attention', 'Failed to request server reboot')
        }
      })
    },
    updateNameField(agGridParams, newValue, afterSave) {
      let apiParams = {
        id: agGridParams.data.id,
        data: {
          name: newValue
        }
      }
      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
    },
    updatePasswordField(agGridParams, newValue, afterSave) {
      let apiParams = {
        id: agGridParams.data.id,
        data: {
          password: newValue
        }
      }
      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
    },
    buildAgGridData(response, silentUpdate) {

      if (silentUpdate) {
        /*
        this.$forceUpdate()
        // this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)*/
        //this.agGrid.rowData[11]['last_heart_beat'] = response.rows[11]['last_heart_beat']
        let index = 0;
        this.agGrid.gridOptions.api.forEachNode(node => {
          node.updateData(response.rows[index++])
        })

        /*this.agGrid.rowData = response.rows;
        this.recordsCounter = response.count;*/
      } else {
        this.agGrid.rowData = response.rows;
        this.recordsCounter = response.count;
      }
    },
    getEntityListData(page, silentUpdate = false) {
      this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response, silentUpdate)
      })
      this.currentPage = page
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('voip-fusion-server-api', {getEntityList: 'list', updateEntity: 'update'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      //$router.push({name : 'module->voip-fusion-server->list->page', params: {listPage: page, this.userSearch}})
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.selectedServer = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.selectedServer.data.id}).then(response => {
        this.agGrid.rowData.splice(this.selectedServer.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        this.deleteDialogVisible = false
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
